import type { SxProps, Theme } from '@mui/material/styles';

const ICON_SIZE = 18;

export const buttonSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  width: '100%',
  minHeight: 36,
  p: 0,
  borderRadius: '4px',
  color: 'primary.main',
  fontFamily: 'inherit',
  textAlign: 'left',
  '&.Mui-disabled': {
    color: 'action.disabled',
  },
};

export const iconWrapperSx: SxProps<Theme> = {
  width: 36,
  height: 36,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

export const iconSx: SxProps<Theme> = { width: ICON_SIZE, height: ICON_SIZE };

export const labelSx: SxProps<Theme> = {
  fontSize: 14,
  lineHeight: theme => theme.typography.button.lineHeight,
  color: 'inherit',
};
